{
	"error": {
		"description": "No se pudo completar.",
		"title": "Oops... Algo no salió según lo planeado."
	},
	"success": "Concluido con éxito!"
}
